import { render, staticRenderFns } from "./error-wrapper.vue?vue&type=template&id=5bb99326&scoped=true&"
import script from "./error-wrapper.vue?vue&type=script&lang=js&"
export * from "./error-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./error-wrapper.vue?vue&type=style&index=0&id=5bb99326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb99326",
  null
  
)

export default component.exports